import { request } from '../utils/request';
import type {
  NotificationLogPayload,
  RegisterNotificationTokenRequest,
} from '../types/notification.types';

// Using direct fetch here instead of request() to avoid app check token and auth token logic
export const logNotificationEvent = (
  payload: NotificationLogPayload,
): Promise<void> => {
  return fetch('/api/notification/log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(() => undefined);
};

export const registerNotificationToken = (
  body: RegisterNotificationTokenRequest,
): Promise<void> => {
  return request('/notification/register-token', {
    method: 'POST',
    body,
  });
};

export const deleteNotificationToken = (token: string): Promise<void> => {
  return request('/notification/delete-token', {
    method: 'DELETE',
    body: { token },
  });
};
